import { useCallback } from 'react';
import { Rect, useReactFlow, useViewport } from '@xyflow/react';
import { getPluginButtonId } from './pluginHelpers';
import { RFEdgeFloatingEdge } from './edges/FloatingEdge';
import { SweepCanvasRfNode } from './canvas-types/nodeTypesData';

/* Public Api to be exposed */

export const useSweepCanvas = () => {
  const rf = useReactFlow<SweepCanvasRfNode, RFEdgeFloatingEdge>();
  const viewport = useViewport();
  const { zoom } = viewport;

  const pluginButtonExists = useCallback((groupId: string, pluginType: PluginTypes) => {
    const element = window.document.getElementById(getPluginButtonId(pluginType, groupId));
    return !!element;
  }, []);

  const removePluginButton = useCallback((groupId: string, pluginType: PluginTypes) => {
    const element = window.document.getElementById(getPluginButtonId(pluginType, groupId));
    if (!element) {
      console.warn(`Plugin button for plugin type ${pluginType} and group id ${groupId} not found`);
      return;
    }
    // Element will be removed when the component unmounts
  }, []);

  const getIntersectingNodes = useCallback(
    (rect: Rect) => {
      const flowPosition = rf.screenToFlowPosition({
        x: rect.x,
        y: rect.y,
      });

      return rf.getIntersectingNodes(
        {
          ...flowPosition,
          width: rect.width / zoom,
          height: rect.height / zoom,
        },
        true,
      );
    },
    [rf, zoom],
  );

  return {
    pluginButtonExists,
    removePluginButton,
    getIntersectingNodes,
    rf,
  };
};
